import Button from "../../Atoms/Button/Button";
import Divider from "../../Atoms/Divider/Divider";
import './HeaderTitle.scss'

const HeaderTitle = ({ headerText, buttonText, downText, withDivider, handleClick }) => {
  return (
    <div>
      <div className="header-title">
        <h1 className="poppins-40 c-dark">{headerText}</h1>
        {buttonText && <Button content={buttonText} type="primary" clickHandler={() => handleClick && handleClick()} />}
      </div>
      {withDivider && <Divider />}
      {downText &&  <p className="source-20 mt-10">{downText}</p>}
    </div>
  );
};

export default HeaderTitle;
